import * as Yup from 'yup';

// Organisation user validation schema
export const OrgUserSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 Characters')
    .required('First name is required'),
  lastName: Yup.string()
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 Characters')
    .required('Last name is required'),

  emailAddress: Yup.string()
    .required('Email address is required')
    .email('Invalid email address')
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 Characters')
});
